import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4cdd5379"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "servicesBackCard" }
const _hoisted_2 = { class: "servicesBackCard__list" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "list__item-line" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _createElementVNode("ul", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.serviceData.back, (service) => {
        return (_openBlock(), _createElementBlock("li", {
          key: service[0],
          class: "list__item"
        }, [
          _createTextVNode(_toDisplayString(service) + " ", 1),
          _hoisted_3
        ]))
      }), 128))
    ])
  ]))
}